import useSWR from 'swr';
import { trpc } from '../../../api/trpc';

export const useAddStoreCardItem = (state?: {
  productId: string;
  modificationId: string;
}) => {
  const { data, isLoading } = useSWR(
    state
      ? ([
          'storeProductCardAdmin.itemInfo',
          { productId: state.productId, modificationId: state.modificationId },
        ] as const)
      : null,
    () =>
      trpc.storeProductCardAdmin.itemInfo.query({
        productId: state!.productId,
        modificationId: state!.modificationId,
      }),
  );

  if (!state) {
    return { data: null };
  }

  return { data, isLoading };
};

export const useAddBrandItem = (state?: { categoryId: number }) => {
  const { data, isLoading } = useSWR(
    state
      ? (['brandAdmin.itemInfo', { categoryId: state.categoryId }] as const)
      : null,
    () =>
      trpc.brandAdmin.itemInfo.query({
        categoryId: state!.categoryId,
      }),
  );

  if (!state) {
    return { data: null };
  }

  return { data, isLoading };
};
